import React, {Component, useContext, useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import { Button, ButtonCancel, ButtonModify, ButtonProceed, ButtonReturn } from '../../../../components/buttons';
import { Layout, MinMaxLayout, SeventyThirtyLayout, SixtyFourtyLayout } from '../../../../layouts';
import Welcome from '../../../../layouts/welcome';
import Row from '../../../../components/row';
import Container from '../../../../layouts/containers/container';
import List from '../../../../components/list';
import ContainerTable from '../../../../layouts/containers/container-table';
import InputsCheckbox from '../../../../components/inputs/inputs-checkbox';
import LabelContainer from '../../../../components/label-container';
import Blurred from '../../../../components/blurred';
import InputsCounter from '../../../../components/inputs/inputs-counter';
import DateTimeInput from '../../components/date-time-input/index';
import meetingsApi from '../../../../lib/meetings/meetings-api';
import ErrorContainer from '../../../../components/error-container';
import InputsText from '../../../../components/inputs/inputs-text';
import MediaHelper from '../../../../lib/helpers/media';
import _ from 'lodash';
import PopupContext from '../../../../context/context-popup';
import coWorkingApi from '../../../../lib/co-working/co-working-api';
import InputsDropdown from '../../../../components/inputs/inputs-dropdown';
import companiesApi from '../../../../lib/companies/companies-api';
import dayjs from 'dayjs';
import BillingDetails from '../../../../components/billing-profile';

const Summary = ({
    costs = null,
    day,
}) => {
    const data = []

    if (costs !== null) {
        costs?.session_items?.forEach((item, index) => {
            let cost = ``;

            if (item?.credits_used !== 0) {
                cost = `${item?.credits_used} credits` 
            }

            if (item?.total !== 0) {
                cost = `£${item?.total}`;
            }

            if (item?.credits_used > 0 && item?.total > 0) {
                cost = `£${item?.total} + ${item?.credits_used} credit(s)`
            }

            data.unshift([
                item?.quantity,
                `${_.capitalize(item?.session)} Session`,
                cost,
            ])
        })
    }

    return (
        <ContainerTable
            showMobileColumns
            headerColor="rgb(146, 155, 168)"
            valueColor="black"
            className="table-bookings"
            columns={[
                { field: 'QTY', width: '25%' },
                { field: 'Item', width: '50%' },
                { field: 'Price/Credit(s)', width: '25%' },
            ]}
            data={[
                ...data
            ]}
        />
    )
}

class CoWorkingSpaceBooking extends Component {
    constructor(props) {
        super(props);

        this.state = {
            agree: false,
            spaces: [],
            space: null,
            errors: {},
            costs: null,
            params: {
                booker_type: 'App\\Models\\User',
                booker_id: window.user.id,
                discount: 0.00,
                day: null,
                morning_session: false,
                afternoon_session: false,
                co_working_space_id: null,
                no_attendees: 1,
                payment_type: 'bacs',
                morning_remaining_capacity: null,
                afternoon_remaining_capacity: null,
            }
        }
    }

    componentDidMount() {
        this.fetchSpaces();
        this.checkQueryParams()
    }

    checkErrors(errors) {
        this.setState({ errors });

        if (errors?.booker_id !== undefined) {
            const details = document.querySelector('.billing-details');

            if (details) details.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    checkQueryParams() {
        const searchParams = new URLSearchParams(window.location.search);

        const no_attendees = searchParams.get('no_attendees');
        const sessions = searchParams.get('sessions');
        const day = searchParams.get('day');
        const space = searchParams.get('space') || searchParams.get('co_working_space_id');

        let params = {}

        if (no_attendees) params.no_attendees = Number.parseInt(no_attendees);
        if (sessions) params.morning_session = sessions === 'day' ? true : sessions === 'morning' ? true : false;
        if (sessions) params.afternoon_session = sessions === 'day' ? true : sessions === 'afternoon' ? true : false;
        if (day) params.day = day;
        if (space) params.co_working_space_id = Number.parseInt(space);

        const hasParams = Object.keys(params)?.length > 0;

        if (hasParams) {
            this.onMultipleChange(params, () => {
                if (space) {
                    this.getBookingCosts();
                    this.fetchSpace();
                }
            });
        }
    }

    fetchSpaces() {
        coWorkingApi.getCoWorkingSpaces().then(({ data }) => {
            this.setState({ spaces: data })
        })
    }

    onChange(e, callback = () => {}) {
        const { name, value } = e.target;
        const params = { ...this.state.params }

        params[name] = value;

        this.setState({ params }, () => {
            callback();

            if (name === 'no_attendees') {
                this.getBookingCosts();
            }
        })
    }

    fetchSpace() {
        coWorkingApi.getCoWorkingSpace(this.state.params?.co_working_space_id).then(({ data }) => {
            this.setState({ space: data });

            this.getRemainingCapacity();
        });
    }

    getRemainingCapacity() {
        const props = this.state.params;
        
        coWorkingApi.getDayAvailability(this.state.params?.co_working_space_id, props).then(({ data }) => {
            const {
                afternoon_remaining_capacity,
                morning_remaining_capacity
            } = data;

            this.onMultipleChange({
                afternoon_remaining_capacity,
                morning_remaining_capacity
            })
        }); 
    }

    getBookingCosts = _.debounce(() => {
        let sessions = []

        if (this.state?.params?.morning_session) {
            sessions = ['morning']
        }

        if (this.state?.params?.afternoon_session) {
            sessions = ['afternoon']
        }

        if (this.state?.params?.morning_session && this.state?.params?.afternoon_session) {
            sessions = ['morning', 'afternoon'];
        }

        coWorkingApi.getBookingCosts(this.state.params?.co_working_space_id, {
            day: this.state.params?.day,
            sessions: sessions,
            discount: this.state.params?.discount,
            no_attendees: this.state.params?.no_attendees,
            booker_id: this.state.params?.booker_id,
            booker_type: this.state.params?.booker_type
        }).then(({ data }) => {
            this.setState({ costs: data });
        });
    }, 500, false);

    onSpaceSelect({ value }) {
        this.onMultipleChange({
            co_working_space_id: value,
            day: null,
            morning_session: false,
            afternoon_session: false,
        }, () => {
            this.fetchSpace();

            this.setState({ costs: null })
        })
    }

    createBooking() {
        coWorkingApi.createCoWorkingBooking(this.state.params, (errors) => {
            this.checkErrors(errors);
        }).then(({ data }) => {
            window.location.href = `/mydmc/co-working/bookings/${data.id}`
        });
    }

    onMultipleChange(e, callback = () => {}) {
        let params = { ...this.state.params }

        params = {
            ...params,
            ...e
        }

        this.setState({ params }, callback);
    }

    onStartChange({ start, afternoon_session, morning_session }) {
        const props = {
            day: start.date,
            afternoon_remaining_capacity: start.afternoon_remaining_capacity,
            morning_remaining_capacity: start.morning_remaining_capacity,
            afternoon_session,
            morning_session,
        }

        this.onMultipleChange(props, () => {
            this.getBookingCosts();
        })
    }

    onAttendeesChange(value) {
        this.onChange({
            target: { name: 'no_attendees', value }
        })
    }

    getFeaturedImage() {
        const image = this.state.space?.content?.feature_image?.[0];

        if (image?.file_name === undefined) return '';

        return MediaHelper.formatPublicPath(`/images/${image?.file_name}`);
    }

    getLocation() {
        const { name, address_one, address_two, address_post_code, address_city } = this.state?.space?.office_building || {
            name: '',
            address_one: '',
            address_two: '',
            address_post_code: '',
            address_city: ''
        };

        let string = [
            name,
            address_one,
            address_two,
            address_post_code,
            address_city
        ].filter(e => e !== undefined && e !== null && e?.length > 0);

        return string.join(', ');
    }

    getAttendeeErrors() {
        if (this.state.errors?.no_attendees) return this.state.errors?.no_attendees;

        const maxCapacity = this.getMaxCapacity();

        if (this.state.params.no_attendees > maxCapacity) return ['Cannot have more than max capacity'];
    }

    getMaxCapacity() {
        let type = null;

        if (this.state.params?.morning_session == true) {
            type = 'morning';
        }

        if (this.state.params?.afternoon_session == true) {
            type = 'afternoon';
        }

        if (this.state.params?.morning_session == true && this.state.params?.afternoon_session == true) {
            type = 'day';
        }

        if (type === 'morning' && this.state.params?.morning_remaining_capacity !== null) return this.state.params?.morning_remaining_capacity;
        if (type === 'afternoon' && this.state.params?.afternoon_remaining_capacity !== null) return this.state.params?.afternoon_remaining_capacity;
        if (type === 'day' && this.state.params?.morning_remaining_capacity !== null && this.state.params?.afternoon_remaining_capacity !== null) return Math.max(this.state.params?.morning_remaining_capacity, this.state.params?.afternoon_remaining_capacity);

        return this.state.space?.capacity_per_session;
    }

    bookDisabled() {
        if (this.state.params?.no_attendees === 0) return true;
        if (this.state.params?.day === null || this.state.params?.day === undefined) return true;
        if (this.state.params?.morning_session === false && this.state.params?.afternoon_session === false) return true;

        if (this.state.agree === true) return false;

        return true;
    }

    render() {
        const featuredImage = this.getFeaturedImage();
        const location = this.getLocation() || 'Not Setup';

        return (
            <Layout 
            theme="light"
            topLeft={<Welcome title="Co-Working" subtitle={this.state.space?.name || 'New Booking'}/>}
            topRight={
                <Row gap="20px">
                    <ButtonReturn responsive onClick={() => window.location.href = `/mydmc/co-working`}>Cancel</ButtonReturn>
                </Row>
            }
        >
            <MinMaxLayout
                main={
                    <div className="booking-view">
                        <List gap="40px" className="booking-view__child">
                            <Container>
                                <Container.Header>
                                    <Container.Text color="#FF6933" fontSize="18px">Confirm Details</Container.Text>
                                </Container.Header>

                                <Container.Content> 
                                    <List gap="40px">
                                        <div className="booking-view__image" style={{ backgroundImage: `url('${featuredImage}')` }}></div>

                                        { this.state.space !== null &&
                                            <>
                                                <LabelContainer label='Booking Type'>
                                                    { this.state.space?.name }
                                                </LabelContainer>

                                                <LabelContainer label='Booking Location'>
                                                    { location }
                                                </LabelContainer>
                                            </>
                                        }

                                        <InputsDropdown
                                            label="Co-Working Space"
                                            value={this.state.params?.co_working_space_id}
                                            items={
                                                this.state.spaces?.map((space) => {
                                                    return {
                                                        label: space?.name,
                                                        value: space?.id
                                                    }
                                                })
                                            }
                                            onChange={this.onSpaceSelect.bind(this)}
                                        />

                                        <Blurred toggled={this.state.space === null}>
                                            <LabelContainer label="Booking Date & Duration">
                                                <ErrorContainer errors={this.state.errors?.day}>
                                                    <DateTimeInput
                                                        onChange={this.onStartChange.bind(this)}
                                                        space={this.state?.space}
                                                        value={{
                                                            start: this.state.params?.day,
                                                            afternoon_session: this.state.params?.afternoon_session,
                                                            morning_session: this.state.params?.morning_session,
                                                        }}
                                                        data={{
                                                            no_attendees: this.state.params?.no_attendees,
                                                        }}
                                                    />
                                                </ErrorContainer>
                                            </LabelContainer>
                                        </Blurred>

                                        <Blurred toggled={this.state.space === null}>
                                            <InputsCounter
                                                label="Number Of Attendees"
                                                min={0}
                                                max={this.getMaxCapacity()}
                                                onChange={this.onAttendeesChange.bind(this)}
                                                value={this.state.params?.no_attendees}
                                                errors={this.getAttendeeErrors()}
                                            />
                                        </Blurred>
                                    </List>
                                </Container.Content>
                            </Container>

                            <ErrorContainer errors={this.state.errors?.booker_id !== undefined ? ['You have not setup a billing profile yet'] : null}>
                                <BillingDetails/>
                            </ErrorContainer>
                        </List>

                        <Container className="booking-view__child">
                            <Container.Header>
                                <Container.Text color="#FF6933" fontSize="18px">Summary</Container.Text>
                            </Container.Header>

                            <Container.Content>
                                <List gap="40px">
                                    <Summary
                                        day={this.state.params?.day}
                                        costs={this.state.costs}
                                    />

                                    <Blurred toggled={this.state.params?.co_working_space_id === null}>
                                        <div className="agree-box" style={{ padding: '0px', gap: '0px' }}>
                                            <div class="bac-bar">
                                                <p style={{ fontSize: '14px' }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                        <path id="Path_689" data-name="Path 689" d="M12,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22ZM11,11v6h2V11Zm0-4V9h2V7Z" transform="translate(-2 -2)" fill="#fcfcfc"/>
                                                    </svg>
                                                    <b>Payment via BACS only</b> or using your <b>Membership Credits</b> (If Available)
                                                </p>
                                            </div>

                                            <div class="agree-box__inner">
                                                <InputsCheckbox
                                                    text="I have read and agree to the booking terms and conditions"
                                                    checked={this.state.agree}
                                                    onChange={(e) => this.setState({ agree: e.value })}
                                                />
                                                <div className="agree-box__content">
                                                    <div className="agree-box__details">
                                                        <List gap="5px">
                                                            { this.state.costs?.credits_available !== undefined && <Container.Text fontSize="16px">{ this.state.costs?.credits_available || 0} credits available</Container.Text> }
                                                            <div className="agree-box-details__detail">
                                                                <p>Credits Due</p>
                                                                <span>{ this.state?.costs?.credits_required_for_full_booking || 0 }</span>
                                                            </div> 
                                                        </List>
                                                        <div className="agree-box-details__detail">
                                                            <p>BACS Due</p>
                                                            <span>£{ this.state?.costs?.total || 0 }</span>
                                                        </div>
                                                    </div>

                                                    <Blurred toggled={this.bookDisabled()}>
                                                        <ButtonModify onClick={this.createBooking.bind(this)}>Complete your booking</ButtonModify>
                                                    </Blurred>
                                                </div>
                                            </div>
                                        </div>
                                    </Blurred>

                                    <Container>
                                        <Container.Header>
                                            <Container.Text fontSize="18px" color="#FF6933">Booking Information</Container.Text>
                                        </Container.Header>

                                        <Container.Content>
                                            <Container.Text fontSize="14px" color="#24191F" html={this.state.space?.booking_information}></Container.Text>
                                        </Container.Content>
                                    </Container>

                                    <Container>
                                        <Container.Header>
                                            <Container.Text fontSize="18px" color="#FF6933">Contact Us</Container.Text>
                                        </Container.Header>

                                        <Container.Content>
                                            <Container.Text fontSize="14px" color="#24191F">
                                                +44 (0)1226 720 700

                                                bookings@barnsleydmc.co.uk

                                                DMC
                                                County Way
                                                Barnsley
                                                S70 2JW
                                                UK
                                            </Container.Text>
                                        </Container.Content>
                                    </Container>
                                </List>
                            </Container.Content>
                        </Container>
                    </div>
                }
            />
        </Layout>    
        )
    }
}

const el = document.getElementById('coworking-booking-new');

if (el) {
    ReactDOM.render(<CoWorkingSpaceBooking/> , el);
}
